import React from 'react';

const shapes = [
  { top: '8%', left: '6%', size: 160, color: 'rgba(252, 165, 165, 0.45)', blur: 0, duration: '9s', delay: '0s' },
  { top: '70%', left: '12%', size: 120, color: 'rgba(96, 165, 250, 0.42)', blur: 4, duration: '11s', delay: '-2s' },
  { top: '18%', left: '70%', size: 140, color: 'rgba(190, 242, 100, 0.4)', blur: 0, duration: '10s', delay: '-1s' },
  { top: '60%', left: '72%', size: 180, color: 'rgba(244, 208, 63, 0.45)', blur: 6, duration: '13s', delay: '-4s' },
  { top: '40%', left: '40%', size: 110, color: 'rgba(196, 181, 253, 0.4)', blur: 2, duration: '12s', delay: '-3s' },
];

const PlayfulBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="absolute inset-0 bg-gradient-to-br from-sky-200 via-white to-emerald-100 opacity-90" />
      {shapes.map(({ top, left, size, color, blur, duration, delay }, index) => (
        <span
          key={index}
          className="floating-shape"
          style={{
            top,
            left,
            width: `${size}px`,
            height: `${size}px`,
            background: color,
            filter: `blur(${blur}px)`,
            animationDuration: duration,
            animationDelay: delay,
          }}
        />
      ))}
    </div>
  );
};

export default PlayfulBackground;
